module.exports = __webpack_public_path__ + "img/07.80d063a6.png";